import React, { useReducer } from "react";
import { reducer, initialState } from "./reducer";

const contextName = "BusinessService";
const StateContext = React.createContext();
const DispatchContext = React.createContext();

export function useBusinessServiceState() {
  const context = React.useContext(StateContext);
  if (context === undefined) {
    throw new Error(
      `useBusinessServiceState must be used within a ${contextName}Provider`
    );
  }
  return context;
}

export function useBusinessServiceDispatch() {
  const context = React.useContext(DispatchContext);
  if (context === undefined) {
    throw new Error(
      `useBusinessServiceState must be used within a ${contextName}Provider`
    );
  }
  return context;
}

export const BusinessServiceProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <StateContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch}>
        {children}
      </DispatchContext.Provider>
    </StateContext.Provider>
  );
};
